import { TabView, TabPanel } from 'primereact/tabview';
import Facturar from './Facturar';
import FacturasHistorial from './FacturasHistorial';

const Facturacion = () => {
  return (
    <TabView>
      <TabPanel header="Generar Factura">
        <Facturar />
      </TabPanel>

      <TabPanel header="Historial">
        <FacturasHistorial />
      </TabPanel>
    </TabView>
  );
};

export default Facturacion;